import {
    CandidateStatusType,
    PayDueType,
    PayLaterMemberStatusType,
    PayLaterPenaltyStatusType,
    PayLaterSignUpStatusType,
    PayMethod,
} from '@web/core/constants'

export const PayLaterPayMethods = [PayMethod.REWARD_POINT, PayMethod.CHARGE_POINT, PayMethod.PAY_LATER]

export const PayLaterUserStatus = {
    /** 정상 */
    NORMAL: 'NORMAL',
    /** 대기 */
    WAITING: 'WAITING',
    /** 거부 */
    DENIED: 'DENIED',
    /** 이용정지 */
    SUSPENDED: 'SUSPENDED',
    /** 연체 */
    OVERDUE: 'OVERDUE',
    /** 해지 */
    LEFT: 'LEFT',
}

export type PayLaterUserStatusType = Constant<typeof PayLaterUserStatus>

type OverduePenaltyStatus = 'NOTICED' | 'BLOCKED'

/**
 * 후불결제 정보 반영여부
 * UNNECESSARY > 변경 불필요
 * NECESSARY > 변경 필요
 * INPROGRESS > 변경중
 * COMPLETED > 변경완료
 */
export const PayLaterInfoStatus = {
    /** 변경 불필요 */
    UNNECESSARY: 'UNNECESSARY',
    /** 변경 필요 */
    NECESSARY: 'NECESSARY',
    /** 변경중 */
    INPROGRESS: 'INPROGRESS',
    /** 변경완료 */
    COMPLETED: 'COMPLETED',
} as const

export type PayLaterInfoStatusType = Constant<typeof PayLaterInfoStatus>

/**
 * 논의내용 참고
 * @see https://oss.fin.navercorp.com/Product-Planning/Paymoney_Paylater_Plan/issues/521#issuecomment-1570979
 */
export const TradeableStatus = {
    /** 거래가능 */
    NORMAL: 'NORMAL',
    /** 사용자 정상상태 아님으로 거래불가 */
    ABNORMAL_USER_STATUS: 'ABNORMAL_USER_STATUS',
    /** 거래가능시간 아니라 거래불가 */
    SYSTEM_CHECK: 'SYSTEM_CHECK',
    /** 허용된 납부일 아니라 거래불가 */
    UNCHANGED_PAYDUE: 'UNCHANGED_PAYDUE',
    /** 한도 부족으로 거래불가 */
    EXCEED_CREDIT_LIMIT_AMOUNT: 'EXCEED_CREDIT_LIMIT_AMOUNT',
    /** 그 외의 상태로 거래불가 */
    UNKNOWN: 'UNKNOWN',
} as const

export type TradeableStatusType = Constant<typeof TradeableStatus>
export interface PayLaterUserInfo {
    /** 페이 회원 번호 */
    payMbrNo: Maybe<number>
    /** 네이버 ID (마스킹 처리) */
    naverId: Maybe<string>
    /** 납부 예정일자 (YYYY.MM.DD) */
    payDueDate: Maybe<string>
    /** 납부 예정일자 */
    payDue: Maybe<PayDueType>
    /** 사용자 상태 */
    userStatus: Maybe<PayLaterUserStatusType>
    /** 잔여 한도 */
    availableAmount: Maybe<number>
    /** 가입대상자 여부 */
    isUserCandidate: boolean
    /** 가입자 여부 */
    isActiveUser: boolean
    /** 납부예정금액 (2개월 이상 연체시, 연체금의 합계) */
    redemptionAmount: Maybe<number>
    /** 연체수수료 */
    overdueFee: Maybe<number>
    /** 장기연체상태 */
    overduePenaltyStatus: Maybe<OverduePenaltyStatus>
    /** 누적이용금액 */
    totalTradeAmount: Maybe<number>
    /** 현재 적립율 */
    rewardRate: Maybe<number>
    /** 사용자 테스트 그룹 유무 */
    isTestGroupUser: boolean
    /** 거래가능상태 */
    tradeableStatus: TradeableStatusType
}

export interface PayLaterState {
    memberStatus: PayLaterMemberStatusType
    /** 납부 예정 일 */
    payDue: Maybe<PayDueType>
    /** 납부 예정 일자 */
    payDueDate: string
    /** 잔여 한도 */
    availableAmount: number
    /** 사용금액 */
    usingAmount: number
    /** 후불결제 항상 전액사용 여부 */
    useAll: boolean
    /** 후불결제 사용 여부 */
    enabled: boolean
    /** 후불결제 연체 정보 */
    overdue: Maybe<{
        /** 후불결제 연체금액 */
        amount: number
        /** 사용자 후불결제 연체 상태 */
        penaltyStatus: Maybe<PayLaterPenaltyStatusType>
    }>
    /** 후불결제 유저 정보 */
    userInfo: {
        maskedNaverId: Maybe<string>
        /** 테스트 그룹 사용자 여부 */
        isTestGroup: boolean
    }
    /** 후불결제 가입 정보 */
    signUpStatus: Maybe<PayLaterSignUpStatusType>
    /**
     * 후불결제 납부일자 유효여부
     * true > 변경 불필요
     * false > 변경 필요
     **/
    payDueValid: Maybe<boolean>
    /** 가입대상자 상태 */
    candidateStatus: CandidateStatusType
    /** 후불결제 사용자 정보 조회 상태 */
    status: Maybe<PayLaterInfoStatusType>
    /** 후불결제 적립률 */
    expectedAccumulateRate?: number
}

export type RootState = {payLater: PayLaterState}
